import zod from 'zod';
import { stringToBoolean, stringToList, stringToListOfNumber, zodLimit, zodPage } from './helpers';
import { PlateType } from '../services/central-api/license-plate-recognition';

const LprLiveEventsSchema = zod.object({
    cameras: stringToList.optional(),
    unitNames: stringToListOfNumber.optional(),
});

const LprLiveAlertsSchema = zod.object({
    cameras: stringToList.optional(),
    unitNames: stringToListOfNumber.optional(),
});

const LprSearchSchema = zod.object({
    plate: zod.string().optional(),
    cameras: stringToList.optional(),
    unitNames: stringToListOfNumber.optional(),
    irregularSituation: stringToBoolean,
    isMotorcycle: stringToBoolean,
    beginIn: zod.coerce.number().optional(),
    endIn: zod.coerce.number().optional(),
    type: zod.string().optional(),
});

const PlatesSchema = zod.object({
    page: zodPage,
    limit: zodLimit(),
    onlyActive: stringToBoolean,
    type: zod.nativeEnum(PlateType).optional(),
    plate: zod.string().optional(),
});

const LprReportsSchema = zod.object({
    page: zodPage,
    limit: zodLimit(),
    textFilter: zod.string().optional(),
});

export const LprSchemas = {
    LprLiveEvents: LprLiveEventsSchema,
    LiveEventLprDetection: zod.object({
        detectionId: zod.coerce.number(),
    }),
    LprLiveAlerts: LprLiveAlertsSchema,
    LiveAlertLprDetection: zod.object({
        detectionId: zod.coerce.number(),
    }),
    LprSearch: LprSearchSchema,
    SearchLprDetection: zod.object({
        detectionId: zod.coerce.number(),
    }),
    Plates: PlatesSchema,
    LprReports: LprReportsSchema,
};
